import React from 'react';
import { connect } from 'react-redux';
import InvoiceParse from './InvoiceParse';
import { fileDelete } from '../../lib/redux/actions/invoiceBatchFiles';
import { hospitalListFetch } from '../../lib/redux/actions/hospitals';
//import { PAYOR_TYPES } from '../../lib/helper/invoice';

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  ...state.invoiceBatchFiles,
  ...state.hospitals,
});

const mapDispatchToProps = {
  fileDelete,
  hospitalListFetch,
};

class InvoiceParseContainer extends React.Component {
  componentDidMount() {
    this.props.hospitalListFetch(1, { pagination: false });
  }

  render() {
    const { files, fileDelete, fileRequestInProgress, isEmbed = false, invoiceBatch = undefined, hospitals = [] } = this.props;

    return (
      <InvoiceParse
        files={files}
        fileDelete={fileDelete}
        fileRequestInProgress={fileRequestInProgress}
        invoiceBatch={invoiceBatch}
        isEmbed={isEmbed}
        hospitals={hospitals}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceParseContainer);
